<div class="h-full relative">
  <network-heading
    style="height: 100%; display: block"
    [text]="text"
    [currentUser]="currentUser"
    [screenWidth]="screenWidth"
    (optionValueEmitter)="selectOption($event)"
    [subText]="subText"
    [id]="id"
    (relationshipListEmitter)="handlerRelationshipList($event)"
    [relationshipType]="relationshipType"
    [currentType]="currentType"
    (moveToNextStepEmitter)="moveToNextStepEmitter.emit()"
  ></network-heading>
</div>
